import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getProjectLicensingFromReducer = get('projects.project.licensing');

export const getIsLoading = state => fromReducer.getIsLoading(getProjectLicensingFromReducer(state));

export const getLicensing = state => fromReducer.getLicensing(getProjectLicensingFromReducer(state));
